import { createAuthorizationHeader, instanceFetch } from '@/fetch';
import { ICheckoutPayLoad, ICPCheckoutResponse, IStripeCheckoutResponse } from '@/core/infra';

type ResponseType = ICPCheckoutResponse | IStripeCheckoutResponse;

export const checkoutPrice = async (payload: ICheckoutPayLoad): Promise<ResponseType> => {
  try {
    const headers = createAuthorizationHeader();
    const response = await instanceFetch.post('/checkout', payload, headers);
    return response as ResponseType;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
